/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Rss_TitleInputs */

const en_blog_rss_title = /** @type {(inputs: Blog_Rss_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Athlete blog`)
};

const pl_blog_rss_title = /** @type {(inputs: Blog_Rss_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog Complete Athlete`)
};

/**
* | output |
* | --- |
* | "Complete Athlete blog" |
*
* @param {Blog_Rss_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_rss_title = /** @type {((inputs?: Blog_Rss_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Rss_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_rss_title(inputs)
	return en_blog_rss_title(inputs)
});